export default "__VITE_ASSET__DHc3Xrab__"